import { marked } from "marked";

/**
 * - Documentation for setting the renderer:
 *   https://marked.js.org/using_pro#renderer
 * - Code for disable auto-linking when there is no protocol in urls was copied and adapted from:
 *   https://github.com/markedjs/marked/issues/882
 */
let renderer = new marked.Renderer();
renderer.link = function (href, title, text) {
    if (renderer.options.sanitize) {
        try {
            let prot = decodeURIComponent(unescape(href))
                .replace(/[^\w:]/g, "")
                .toLowerCase();

            if (prot.indexOf("javascript:") === 0 || prot.indexOf("vbscript:") === 0 || prot.indexOf("data:") === 0) {
                return "";
            }
        } catch (e) {
            return "";
        }
    }

    // Only interpret links that contain a protocol
    if (!text.startsWith("http://") && !text.startsWith("https://")) {
        return text;
    }

    return `<a href="${ href }">${ text }</a>`;
};
marked.setOptions({ renderer, breaks: true });

export function parseMarkup(markup: string): string {
    return marked.parse(markup);
}
